import moment from "moment"
import { get, post } from "../api"
import * as url from "./urls"

const all = (filters, offset, limit = 20) => {
  const allFilters = {
    ...filters,
    startAt: filters.startAt
      ? moment(filters.startAt).format("YYYY-MM-DD")
      : null,
    endAt: filters.endAt ? moment(filters.endAt).format("YYYY-MM-DD") : null,
  }
  return get(url.ALL_ORDERS, {
    params: {
      ...allFilters,
      offset,
      limit,
    },
  })
}

const getOrderOptions = () => {
  return get(url.GET_ORDERS_OPTIONS)
}

const getAllStatus = () => {
  return get(url.GET_ALL_STATUS)
}

const allHistory = (filters, offset, limit = 20) => {
  const allFilters = {
    ...filters,
    startAt: filters.startAt
      ? moment(filters.startAt).format("YYYY-MM-DD")
      : null,
    endAt: filters.endAt ? moment(filters.endAt).format("YYYY-MM-DD") : null,
  }
  return get(url.GET_HISTORY, {
    params: {
      ...allFilters,
      offset,
      limit,
    },
  })
}

const allOnlyKey = (filters, offset, limit = 20) => {
  const allFilters = {
    ...filters,
    startAt: filters.startAt
      ? moment(filters.startAt).format("YYYY-MM-DD")
      : null,
    endAt: filters.endAt ? moment(filters.endAt).format("YYYY-MM-DD") : null,
  }
  return get(url.GET_ONLYKEY, {
    params: {
      ...allFilters,
      offset,
      limit,
    },
  })
}

const find = async q => {
  const endpoint = url.ORDER_DETAIL_BY_ID.replace(":q", q)
  return get(endpoint)
}

const searchType = async (q, type, product) => {
  const endpoint = url.SEARCH_DYNAMIC.replace(":q", q)
    .replace(":type", type)
    .replace(":product", product)
  return get(endpoint)
}

const doBatchSearch = async (formData, query, offset, limit = 20) => {
  return post(url.BATCH_INPUT, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    params: { ...query, offset, limit },
  })
}

const fetchCheckboxes = () => {
  return get(url.CHECKBOXES)
}

const allNoLimit = (
  filters,
  addToQueue,
  userId,
  fileType,
  baseType,
  checkboxes
) => {
  const allFilters = {
    ...filters,
    startAt: moment(filters.startAt).format("YYYY-MM-DD"),
    endAt: moment(filters.endAt).format("YYYY-MM-DD"),
  }
  return get(url.ORDER_REPORT, {
    params: {
      filters: allFilters,
      userId,
      addToQueue,
      fileType,
      baseType,
      checkboxes: JSON.stringify(checkboxes),
    },
  })
}

const allNoLimitFile = (
  filters,
  formData,
  addToQueue,
  userId,
  fileType,
  baseType,
  checkboxes
) => {
  const allFilters = {
    ...filters,
    startAt: moment(filters.startAt).format("YYYY-MM-DD"),
    endAt: moment(filters.endAt).format("YYYY-MM-DD"),
  }

  formData["addToQueue"] = addToQueue
  formData["userId"] = userId
  formData["filters"] = JSON.stringify(allFilters)
  formData["fileType"] = fileType
  formData["baseType"] = baseType
  formData["checkboxes"] = JSON.stringify(checkboxes)

  return post(url.POST_REPORT_FILE, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
}

const allNoLimitV2 = (
  filters,
  addToQueue,
  userId,
  fileType,
  baseType,
  checkboxes
) => {
  const allFilters = {
    ...filters,
    startAt: moment(filters.startAt).format("YYYY-MM-DD"),
    endAt: moment(filters.endAt).format("YYYY-MM-DD"),
  }
  return post(url.ORDER_REPORT, {
    filters: allFilters,
    userId,
    addToQueue,
    fileType,
    baseType,
    checkboxes: JSON.stringify(checkboxes),
  })
}

const getOrder = id => {
  const endpoint = url.GET_ORDER.replace(":id", id)
  return get(endpoint)
}

const updateCourier = async (orders, newCourier, query) => {
  try {
    const ids = orders.map(x => {
      return { id: x.id, shippingCompanyId: x.shippingCompany.id }
    })
    const response = await post(url.UPDATE_ORDER_COURRIER, {
      ids,
      newCourier,
      query,
    })
    return [response.data, null]
  } catch (e) {
    if (e.response) {
      return [null, e.response]
    }
    if (e.request) {
      return [null, e.request]
    }
    return [null, e]
  }
}

const updateStatus = async (orders, newState, query) => {
  try {
    const ids = orders.map(x => {
      return { id: x.id, currentStatusId: x.currentStatus.id }
    })
    const response = await post(url.UPDATE_ORDER_STATE, {
      ids,
      newState,
      query,
    })
    return [response.data, null]
  } catch (e) {
    if (e.response) {
      return [null, e.response]
    }
    if (e.request) {
      return [null, e.request]
    }
    return [null, e]
  }
}

const getOrderBatchOptions = async () => {
  return get(url.GET_ORDER_BATCH_OPTIONS)
}

const getOrderBatchMonitor = async () => {
  return get(url.GET_ORDER_BATCH_MONITOR)
}

const insertBatchFile = async formData => {
  try {
    const { payload } = await post(url.POST_ORDER_BATCH_FILE, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    return { response: payload.data }
  } catch (e) {
    throw new Error(e)
  }
}

const postHistoryReport = (courier, dates, status, userId) => {
  const allFilters = {
    courierId: courier,
    startAt: moment(dates.startAt).format("YYYY-MM-DD"),
    endAt: moment(dates.endAt).format("YYYY-MM-DD"),
    status: status ? status : [],
  }
  return post(url.ORDER_HISTORY, {
    filters: allFilters,
    userId,
  })
}

const postUpdateStatusAR = id => {
  return post(url.UPDATE_ORDER_STATUS_BY_AR, {
    id: id
  })
}

const postFileBatimento = async formData => {
  return post(url.POST_BATIMENTO_FATURAMENTO, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
}

const postFaturamentoEmbossing = async formData => {
  return post(url.POST_FATURAMENTO_EMBOSSING, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
}

export {
  getOrderOptions,
  all,
  allHistory,
  allNoLimit,
  allNoLimitFile,
  allNoLimitV2,
  allOnlyKey,
  doBatchSearch,
  find,
  getAllStatus,
  getOrder,
  getOrderBatchMonitor,
  getOrderBatchOptions,
  insertBatchFile,
  searchType,
  updateCourier,
  updateStatus,
  postHistoryReport,
  postUpdateStatusAR,
  postFileBatimento,
  postFaturamentoEmbossing,
  fetchCheckboxes,
}
